export function navigateToValidationPharma(commandeId) {
    globalThis.location.href = `/validation-pharma?commandeId=${commandeId}`;
}
